<template>
  <div
    class="ui-avatar-placeholder"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <img
      class="ui-avatar-placeholder__img"
      :src="randomImage"
    >
  </div>
</template>

<script>
export default {
  name: 'UiAvatarPlaceholder',

  props: {
    size: {
      type: [Number, String],
      default: 96
    }
  },

  data() {
    return {
      images: [
        require('@/assets/hometeacher/images/bird02.png'),
        require('@/assets/hometeacher/images/bird03.png'),
      ],
    }
  },

  computed: {
    randomImage() {
      return this.images[Math.floor(Math.random() * this.images.length)];
    }
  }
}
</script>

<style>
  .ui-avatar-placeholder {
    align-items: center;
    background-color: #e6f0f2;
    border-radius: 50%;
    box-shadow: inset 0 -8px 0 #d8e3e9;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
  }
  .ui-avatar-placeholder__img {
    max-height: 60px;
    max-width: 60px;
    border-radius: 0 !important;
    object-fit: contain !important;
  }
</style>
